import { ref } from "vue";

import store from "../state/store"


export default function useCooperationRequests() {

    const search = ref("")
    const perPage = ref(10)
    const sortField = ref("updated_at")
    const sortDirection = ref("desc")
    const loading = ref(false)



    const getCooperationRequests = (url = null) => {
        store.dispatch("getCooperationRequests", {
            url,
            search: search.value,
            per_page: perPage.value,
            sort_field: sortField.value,
            sort_direction: sortDirection.value,
        })
    }

    return {
        search,
        perPage,
        sortField,
        sortDirection,
        loading,
        getCooperationRequests,
    }
}